import React from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import labels from "../../../../constants/displayFields";
import BaseInfoModal from "./BaseInfoModal";
import useInventoryRequestData from "./hooks/useInventoryRequestData";

export default function ReservedQuantityInfoModal({ asset, onClose }) {
  const { loading, error, getQuantityText } = useInventoryRequestData(
    "reservations",
    asset?.itemId
  );

  const quantityText = getQuantityText(asset);
  const reservedQuantity = parseInt(quantityText) || 0;

  return (
    <BaseInfoModal
      title={labels.reserved_quantity}
      onClose={onClose}
      loading={loading}
      error={error?.message}
    >
      {reservedQuantity > 0 ? (
        <TextField
          value={quantityText}
          variant="outlined"
          size="small"
          fullWidth
          label={labels.reserved_quantity}
          InputProps={{
            readOnly: true,
          }}
          sx={{ mt: 2 }}
        />
      ) : (
        <Typography color="text.secondary" align="center" pt={4}>
          No reservations currently include this asset
        </Typography>
      )}
    </BaseInfoModal>
  );
}
